import React from 'react'
import cx from 'classnames'

import styles from '../scss/ui/share.scss'

const Loading = () => (
    <div className={styles.share}>
        <div className={cx(styles.shareCenter, 'vertical-middle center-content')}>
            <div className={styles.loadingAnimation} />
            <h2>Loading...</h2>
        </div>
    </div>
)

export default Loading



// WEBPACK FOOTER //
// ./src/ui/Loading.js